export default __webpack_public_path__ + "static/ConfirmationGate-19517dc034273108c58933a94e5723f8.png";